import axios from "axios";

export const register = (userData) => axios.post(`/auth/register`, userData);

export const upgradeGuestAccount = (userData) =>
  axios.post(`/auth/guest/upgrade`, userData);

export const login = (userData) => axios.post(`/auth/login`, userData);

export const verifyEmail = (verificationData) =>
  axios.post(`/auth/verify-email`, verificationData);

export const resendEmailVerification = (verificationData) =>
  axios.post(`/auth/resend-verification-email`, verificationData);

export const loginAsGuest = () => axios.post(`/auth/guest`);

export const logout = () => axios.post(`/auth/logout`);

export const checkIdentifierAvailability = (identifier) =>
  axios.get(`/auth/check-nickname`, {
    params: {
      identifier,
      nickname: identifier,
    },
  });

export const checkNicknameAvailability = checkIdentifierAvailability;
